<template>
  <div>
    <v-checkbox
      v-model="isReceiveEmail"
      :label="$t('Setting.Email.NotifyNewTask')"
      hide-details
    />
    <div v-if="isReceiveEmail">
      <v-row>
        <v-col
          cols="12"
          md="6"
        >
          <v-text-field
            v-model="email"
            :label="$t('Setting.Email.YourEmail')"
          />
        </v-col>
      </v-row>
      {{ $t('Setting.Email.SendTime') }}
      <v-row>
        <v-checkbox
          v-for="time in staffTaskReminderEmailTimeType"
          :key="time.id"
          v-model="selectedTime"
          :label="time.time"
          :value="time.id"
          class="mx-4"
        />
      </v-row>
      <br>
      <v-row>
        <v-col
          cols="12"
          md="6"
        >
          {{ $t('Setting.Email.ImmediateSendSetting') }}
          <v-select
            v-model="selectedStaffTaskReminderType"
            :items="staffTaskReminderType"
            item-value="id"
            :item-text="$chPtField('chinDesc')"
            hide-details
          />
        </v-col>
      </v-row>
    </div>
    <br>
    <v-btn
      color="primary"
      @click="updateEmailSetting"
    >
      {{ $t('Setting.Email.UpdateSetting') }}
    </v-btn>
  </div>
</template>

<script>

import reminderEmailApi from '@/api/hr/reminderEmail'
import { EMAIL_REMINDER_TYPE } from '@/constant/constant'
import { globalModule } from '@/store/moduleName'

export default {
  data: () => ({
    isReceiveEmail: false,
    email: null,
    selectedTime: [],
    staffTaskReminderEmailTimeType: [],
    staffTaskReminderType: [],
    selectedStaffTaskReminderType: EMAIL_REMINDER_TYPE.NONE
  }),
  created () {
    reminderEmailApi.getEmailWithTime(resp => {
      if (resp.status === 201 || resp.status === 200) {
        if (resp.data.email) {
          this.isReceiveEmail = true
          this.email = resp.data.email
          this.selectedTime = []
          resp.data.timeDetails.forEach(time => {
            this.selectedTime.push(time.timeTypeId)
          })
          this.selectedStaffTaskReminderType = resp.data.reminderTypeId
        }
      }
    })
    reminderEmailApi.staffTaskReminderEmailTimeType(resp => {
      if (resp.status === 201 || resp.status === 200) {
        this.staffTaskReminderEmailTimeType = resp.data
      }
    })
    reminderEmailApi.staffTaskReminderType(resp => {
      if (resp.status === 201 || resp.status === 200) {
        this.staffTaskReminderType = resp.data
      }
    })
  },
  methods: {
    updateEmailSetting () {
      if (this.email.length > 100) {
        this.$store.dispatch(globalModule + '/setErrorMessage', this.$t('Training.Error.MaxChar', [this.$t('TaskList.Setting.Email'), 100]))
        return false
      }

      if (this.isReceiveEmail && !this.email) {
        this.$store.dispatch(globalModule + '/setErrorMessage', this.$t('Error.PlsFillIn', [this.$t('TaskList.Setting.Email')]))
        return false
      }

      if (!this.isReceiveEmail) {
        reminderEmailApi.deleteEmail(resp => {
          if (resp.status === 201 || resp.status === 200) {
            this.email = null
            this.selectedTime = []
            this.$store.dispatch(globalModule + '/setErrorMessage', this.$t('Message.Action.UpdateSuccess'))
          }
        })
      } else {
        reminderEmailApi.updateEmailWithTime(this.email, this.selectedTime, this.selectedStaffTaskReminderType, resp => {
          if (resp.status === 201 || resp.status === 200) {
            this.$store.dispatch(globalModule + '/setErrorMessage', this.$t('Message.Action.UpdateSuccess'))
          }
        })
      }
    }
  }
}
</script>
